// Generated by CoffeeScript 2.7.0
var LogicalCheckBoxMixin;

export default LogicalCheckBoxMixin = {
  methods: {
    debouncedHandleLogic: function() {
      var option;
      if (this.visible) {
        if (this.logical) {
          this.currentHittedFieldIds = [];
          option = _.first(this.value);
          return _.each(this.value, (option) => {
            return _.each(this.field.logic_rule, (raw_judgement) => {
              if (Skylark.App.Judgement.validate(option.id, raw_judgement)) {
                return this.currentHittedFieldIds = this.currentHittedFieldIds.concat(raw_judgement.field_ids);
              }
            });
          });
        }
      } else {
        return this._clearValue();
      }
    }
  }
};
